import { keys } from "@/lib/i18n/portal";

/**
 * Which sentence a 403 from `POST /seller/auth/login` gets. The phone and
 * password were right in both cases; what differs is why the door is shut:
 * - `SELLER_NO_STORE`: the account belongs to no store any more (its team seat
 *   was removed) — the owner can add it again, or the seller can open a store;
 * - `STORE_DEACTIVATED`: an admin deactivated the store — Trioty support;
 * - anything else: the store access is inactive — support can help.
 */
export function loginForbiddenMessageKey(code: string | undefined | null): string {
  if (code === "STORE_DEACTIVATED") return keys.errors.storeDeactivated;
  return code === "SELLER_NO_STORE"
    ? keys.errors.sellerNoStore
    : keys.errors.inactiveSellerAccess;
}
